"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var mobx_react_1 = require("mobx-react");
var mui_1 = require("tss-react/mui");
var react_error_boundary_1 = require("react-error-boundary");
// icons
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
// locals
var ErrorMessage_1 = __importDefault(require("./ErrorMessage"));
var useStyles = (0, mui_1.makeStyles)()(function (theme) {
  return {
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  };
});
function DialogError(_ref) {
  var error = _ref.error;
  return react_1.default.createElement("div", {
    style: {
      width: 800,
      margin: 40
    }
  }, react_1.default.createElement(ErrorMessage_1.default, {
    error: error
  }));
}
function JBrowseDialog(props) {
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var title = props.title,
    children = props.children,
    onClose = props.onClose;
  return react_1.default.createElement(material_1.Dialog, _objectSpread({}, props), react_1.default.createElement(material_1.ScopedCssBaseline, null, react_1.default.createElement(material_1.DialogTitle, null, title, onClose ? react_1.default.createElement(material_1.IconButton, {
    className: classes.closeButton,
    onClick: function onClick() {
      // @ts-ignore
      onClose();
    }
  }, react_1.default.createElement(Close_1.default, null)) : null), react_1.default.createElement(material_1.Divider, null), react_1.default.createElement(react_error_boundary_1.ErrorBoundary, {
    FallbackComponent: DialogError
  }, children)));
}
exports.default = (0, mobx_react_1.observer)(JBrowseDialog);